import clsx from 'clsx'

export function DiscordIcon({ className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      className={clsx('text-[#5B5B5B]', className)}
      aria-hidden="true"
    >
      <g clipPath="url(#clip0_3324_2620)">
        <path
          d="M21.8156 4.95965C20.2231 4.22893 18.5153 3.69054 16.7296 3.38215C16.6971 3.3762 16.6646 3.39108 16.6479 3.4208C16.4282 3.81147 16.1849 4.32107 16.0146 4.72164C14.094 4.43409 12.1833 4.43409 10.3022 4.72164C10.1318 4.31218 9.87964 3.81147 9.65901 3.4208C9.64227 3.39206 9.60976 3.37718 9.57726 3.38215C7.79265 3.68951 6.08485 4.2279 4.49125 4.95965C4.47744 4.9656 4.46563 4.97551 4.45777 4.98839C1.21845 9.8279 0.331021 14.5485 0.76634 19.2105C0.768292 19.2333 0.781127 19.2551 0.798843 19.269C2.93606 20.8386 5.00636 21.7914 7.03816 22.423C7.07066 22.4329 7.10512 22.421 7.12581 22.3942C7.60642 21.7379 8.03485 21.0458 8.40219 20.318C8.42386 20.2754 8.40317 20.2248 8.35885 20.208C7.67928 19.9502 7.03221 19.6359 6.40973 19.279C6.36049 19.2502 6.35653 19.1798 6.40187 19.1461C6.53286 19.0479 6.66389 18.9458 6.78897 18.8427C6.81162 18.8238 6.84314 18.8199 6.86974 18.8317C10.959 20.6988 15.3861 20.6988 19.4271 18.8317C19.4537 18.8189 19.4853 18.8229 19.5089 18.8417C19.634 18.9448 19.765 19.0479 19.897 19.146C19.9423 19.1798 19.9393 19.2502 19.8901 19.2789C19.2676 19.6428 18.6205 19.9502 17.94 20.207C17.8957 20.2238 17.8759 20.2754 17.8977 20.318C18.2729 21.0447 18.7013 21.7368 19.1731 22.3932C19.1928 22.421 19.2282 22.4329 19.2607 22.4229C21.3024 21.7914 23.3727 20.8385 25.5099 19.269C25.5286 19.2551 25.5404 19.2343 25.5424 19.2115C26.0634 13.8217 24.6698 9.13979 21.848 4.98937C21.8412 4.97551 21.8294 4.9656 21.8156 4.95965ZM9.01296 16.3718C7.78181 16.3718 6.76735 15.2415 6.76735 13.8534C6.76735 12.4653 7.7621 11.335 9.01296 11.335C10.2736 11.335 11.2782 12.4752 11.2585 13.8534C11.2585 15.2415 10.2637 16.3718 9.01296 16.3718ZM17.3156 16.3718C16.0845 16.3718 15.07 15.2415 15.07 13.8534C15.07 12.4653 16.0648 11.335 17.3156 11.335C18.5763 11.335 19.5809 12.4752 19.5612 13.8534C19.5612 15.2415 18.5763 16.3718 17.3156 16.3718Z"
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_3324_2620">
          <rect
            width="24.9869"
            height="24.9869"
            fill="currentColor"
            fillRule="evenodd"
            clipRule="evenodd"
            transform="translate(0.663086 0.410156)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
